import { createRoute } from '@tanstack/react-router';
import { SuppliersPage } from '@/features/stock/SuppliersPage';
import { Route as shellRoute } from '../_shell';

/** Supplier cards: structured contact and measured lead times, with the sample size. */
export const Route = createRoute({
  getParentRoute: () => shellRoute,
  path: '/stock/suppliers',
  component: SuppliersPage,
});
